import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {Link, withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import * as cartActions from '../../actions/cartActionCreators';
import {useMount, useUnmount} from 'react-use';
import useQueryParam from '../../tools/useQueryParam';
import Cart from '../../components/Cart';
import constants from '../../constants';
import {priceFormat, priceWithCurrency, productsCountFrom} from '../../tools/formatters';
import './style.scss';

let observeInterval = null;
const RemotePayPage = (props) => {
  const
    {cartState, applicationState, cartActions} = props,
    order_id = useQueryParam('order_id'),
    summ = useQueryParam('summ'),
    {is_mobile} = applicationState,
    {remote_pay, remote_pay_order} = cartState;

  useMount(() => {
    cartActions.fetchOrderPayment(order_id);
    if (!remote_pay.is_succeeded && !remote_pay.is_canceled && !remote_pay.is_expired) {
      observeInterval = setInterval(() => {
        cartActions.fetchOrderPayment(order_id);
      }, 1200)
    }
  });

  useUnmount(() => {
    clearInterval(observeInterval);
  })

  if (!remote_pay || !remote_pay_order) {
    return null;
  }

  return (
    <Layout
      breadcrumbs={props.applicationState.is_mobile ? null : [
        {label: 'Оплата счёта'}
      ]}
      className='remote-pay-page'
    >
      <div className='container'>
        <h1>
          Счет № {remote_pay_order.order_id}
        </h1>
        <div className='sbr-remote-pay-page'>
          <div className='sbr-remote-pay-page-title'>
            {
              remote_pay.paid ?
                <div className='message-'>Оплата успешно завершена.</div>
                :
                remote_pay.payment_url ?
                  <>
                    <a className='ant-btn ant-btn-text st-btn primary md' href={remote_pay.payment_url}>Оплатить {priceWithCurrency(remote_pay_order.subtotal)}</a>
                    <div className='sbr-remote-pay-page-time'>
                      {
                        remote_pay.is_expired ?
                          <>Истек срок ожидания ввода данных.</>
                          : <>{remote_pay.human_time_left}</>
                      }
                    </div>
                  </>

                  :

                  <>
                  {remote_pay.cancellation_human_reason ? <div className='message-'>{remote_pay.cancellation_human_reason}</div> : null}
                  </>
            }
          </div>
        </div>

      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      cartActions: bindActionCreators(cartActions, dispatch)
    };
  },

  mapStateToProps = ({cartState, railsContext, applicationState}) => {
    return {
      applicationState,
      cartState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(RemotePayPage));
